import { v4 as uuidv4 } from 'uuid';


class Nonmember {
    public hashId: string;
    private key: string = 'saa-hashId';
    constructor() {
        // Reuse existing id if present; only generate once when missing
        if (typeof window !== 'undefined') {
            const existing = localStorage.getItem(this.key);
            if (existing && existing.length > 0) {
                this.hashId = existing;
                return;
            }
        }
        this.hashId = this.generateHashId();
        this.saveHashId();
    }

    private generateHashId(): string {
        const id = uuidv4();
        const hashId = id || (typeof crypto !== 'undefined' && 'randomUUID' in crypto ? (crypto as any).randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
        return hashId;
    }

    public saveHashId(): void {
        if (typeof window !== 'undefined') {
            localStorage.setItem(this.key, this.hashId);
        }

    }

    public getHashId(): string | null {
        if (typeof window !== 'undefined') {
            const existing = localStorage.getItem(this.key);
            if (existing && existing.length > 0) return existing;
            const generated = this.generateHashId();
            localStorage.setItem(this.key, generated);
            this.hashId = generated;
            return generated;
        }
        return null;
    }

    public removeHashId(): void {
        if (typeof window !== 'undefined') {
            localStorage.removeItem(this.key);
        }
    }

}

export default Nonmember;
